import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { CouponCodeModel } from '../model/couponCode.model';

@Injectable()
export class CouponCodeService {
    private headers = new Headers({
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    });
    private couponCodeUrl = 'api/couponCode';

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getCouponCodeList(query: any): Promise<CouponCodeModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.couponCodeUrl}/couponCodeList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    deleteCouponCode(id: any): Promise<CouponCodeModel> {
        const url = `${this.couponCodeUrl}/deleteCouponCode`;
        return this.http
            .post(url, $.param({ id: id }), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as CouponCodeModel)
            .catch(this.handleError);
    }

    addUpdateCouponCode(couponCodeData: any): Promise<CouponCodeModel> {
        const url = `${this.couponCodeUrl}/addUpdateCouponCode`;
        return this.http
            .post(url, $.param(couponCodeData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as CouponCodeModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/couponCode.service.ts